// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__4z9DU","cell":"TableRow_cell__pdOO5"};